import { makeHttpGet } from '../';
import { RelatedFundsUseCase } from '../../usecases';
import { IRelatedFunds } from '../../main/comparison-fund/dto';

export const makeRelatedFunds = () => {
  const httpGet = makeHttpGet<IRelatedFunds[]>();

  return new RelatedFundsUseCase(
    httpGet
  );
}
